import { CuepointType } from "../types/common";
import { Cuepoint } from "../types/player-api";

export const findCuepoint = (
  type: CuepointType,
  cuepoints?: Cuepoint[]
): Cuepoint | undefined => cuepoints?.find(cuepoint => cuepoint.kind === type);

export const isCuepointVisible = (
  started: boolean,
  currentTime: number,
  cuepoint?: Cuepoint,
  duration?: number
): boolean =>
  started &&
  cuepoint !== undefined &&
  currentTime > cuepoint.start_time &&
  (!cuepoint.end_time || currentTime < cuepoint.end_time) &&
  (!duration || Math.floor(currentTime) < Math.floor(duration));
